var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDummyPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 837,
    height: 837,
    viewBox: "0 0 837 837",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M836.02 418.01C836.02 530.201 791.819 632.07 719.883 707.15C643.798 786.572 536.677 836.02 418.01 836.02C299.343 836.02 192.222 786.572 116.137 707.15C44.201 632.069 0 530.201 0 418.01C0 187.152 187.152 0 418.01 0C648.868 0 836.02 187.152 836.02 418.01Z",
    fill: "#E7E7E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M418.01 440.443C512.323 440.443 588.778 363.988 588.778 269.675C588.778 175.363 512.323 98.9072 418.01 98.9072C323.698 98.9072 247.242 175.363 247.242 269.675C247.242 363.988 323.698 440.443 418.01 440.443Z",
    fill: "#B0B6B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M705.718 672.59C702.371 676.374 698.946 680.096 695.447 683.746C625.52 756.739 527.072 802.184 418.009 802.184C308.946 802.184 210.498 756.739 140.571 683.746C137.073 680.097 133.648 676.375 130.3 672.59C181.763 565.5 291.257 491.575 418.009 491.575C544.761 491.575 654.256 565.501 705.718 672.59Z",
    fill: "#B0B6B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummyPerson);
export default __webpack_public_path__ + "static/media/DummyPerson.c912a1228d61e0621e09ac484c8ac66c.svg";
export { ForwardRef as ReactComponent };